import React, {Component} from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {Grid, IconButton, Popper, Tooltip} from "@mui/material";
import AppsIcon from '@mui/icons-material/Apps';
import {debounce} from "../../utils/utils";
import {toggleAiChatPopout} from "./utils/slide_ai_popout";
import {requestOsdApp} from "./openseadragon/viewerSelection";

class AppTabs extends Component {

	constructor(props) {
		super(props);
		this.ref = React.createRef();
		this.allAppsKey = {
			id: "all-apps",
			title: "All Apps",
			showTitleOnHover: true,
			icon: <AppsIcon sx={{fontSize: 'inherit'}}/>,
			component: this.getAllAppsComponent(),
		}
		this.tabs = [this.props.allAppsTab ? this.getTab(this.allAppsKey) : undefined,
			...this.props.apps.filter(app => app.makeSideBarIcon).map(app => this.getTab(app))];
	}

	componentDidMount = () => {
		this.debounceFunc = debounce(this.resizeListener, 400)
		window.addEventListener("resize", this.debounceFunc);
	}
	componentWillUnmount = () => {
		window.removeEventListener("resize", this.debounceFunc);
	};
	resizeListener = () => {
		this.forceUpdate()
	}

	getAllAppsComponent = () =>
		<Grid container>
			{this.props.apps.map(app =>
				<Grid item xs={4} textAlign={"center"} key={app.id || app.title}>
					<IconButton onClick={() => this.selectApp(app)} size={'large'} color={'secondary'}>
						{app.icon}
					</IconButton>
					<Typography noWrap={true}>{app.title}</Typography>
				</Grid>
			)}
		</Grid>

	/** Single entry-point for app selection (avoids Tab onClick + Tabs onChange double-toggle). */
	selectApp = (value) => {
		if (!value) return;
		if (value.openAsRightPanel) {
			// Morpho Chat: right Drawer only — never the left Popper.
			requestOsdApp(value).then(proceed => {
				if (!proceed) return;
				if (this.props.open) this.props.openApp(false);
				toggleAiChatPopout();
			});
			return;
		}
		this.props.openApp(value === this.props.open ? false : value);
	}

	getTab = (app) =>
		<Tooltip title={app.showTitleOnHover ? app.title : ""} placement={"right"} key={app.id || app.title}>
			<Tab icon={app.icon} value={app} id={app.id} className={app?.className}
			     sx={{fontSize: '25px'}}/>
		</Tooltip>;

	render() {
		return <Box ref={this.ref} display={"flex"} width={"fit-content"} minWidth={"51px"} alignItems={this.props.alignItems}
		            height={this.props.height} bgcolor={"background.paper"}>
			<Tabs orientation="vertical" variant="scrollable"
				  onChange={(_e, value) => this.selectApp(value)}
				  value={this.props.open || false}
				  sx={{
					  borderRight: 1, borderColor: "divider",
					  height: this.props.allAppsTab ? this.props.height : null,
					  marginBottom: document.documentElement.clientHeight < 450 ? 4 : 2
				  }}>
				{this.tabs}
			</Tabs>
			<Popper open={!!this.props.open} anchorEl={this.ref.current} placement={"right-start"}
					sx={{
						height: this.props.height,
						width: '310px', bgcolor: 'background.paper',
						overflow: 'auto', padding: 2, border: 1, borderColor: 'divider'
					}}>
				{this.props.open && this.props.open.permission !== false && this.props.open.component}
			</Popper>
		</Box>
	}
}

export default AppTabs;
